"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.avatarSize = exports.Avatar = void 0;
var utility_1 = require("@taraai/utility");
var react_1 = __importDefault(require("react"));
var Box_1 = require("./Box");
var core_1 = require("./core");
var typography_1 = require("./typography");
function Avatar(_a) {
    var url = _a.url, title = _a.title;
    if (url)
        return react_1.default.createElement(ImageStyled, { src: url });
    if (title)
        return react_1.default.createElement(Initials, { title: title });
    return placeholderAvatar;
}
exports.Avatar = Avatar;
exports.avatarSize = core_1.getCustomSize(16);
var ImageStyled = core_1.styled('img', {
    borderRadius: '$circle',
    height: exports.avatarSize,
    width: exports.avatarSize,
    objectFit: 'cover',
});
var Initials = function (_a) {
    var title = _a.title;
    var initials = utility_1.getInitials(title);
    return (react_1.default.createElement(InitialsStyled, { borderRadius: '$circle', center: true, spaceBottom: '$2px' },
        react_1.default.createElement(typography_1.Text, { color: '$focus', size: '$10px', weight: 'medium' }, initials)));
};
var InitialsStyled = core_1.styled(Box_1.Box, {
    height: exports.avatarSize,
    backgroundColor: '#DDF0FF',
    width: exports.avatarSize,
});
var placeholderAvatar = (react_1.default.createElement("svg", { style: { fill: core_1.tokens.colors.$focus, height: exports.avatarSize.value, width: exports.avatarSize.value }, xmlns: 'http://www.w3.org/2000/svg' },
    react_1.default.createElement("rect", { fillOpacity: '.15', height: '16', rx: '8', width: '16' }),
    react_1.default.createElement("circle", { cx: '8', cy: '6', r: '2' }),
    react_1.default.createElement("ellipse", { cx: '8', cy: '10.75', rx: '4', ry: '2.25' })));
